import React, { Component } from "react";
import { connect } from 'react-redux';
import View from './views';
import FireboardUtils from '../../util/fireboard-util';
import { dispatchUpdateChecks } from "../../store";
import constants from "../../globalization";
import {
  LogLevelEnum,
} from "../../enums";
import { getPopupConfig } from "../../components/Popup";
import DBManager from "../../services/db-manager";
import EventEmitter from '../../util/event-emitter';
import CommonUtil from "./common";
import { updateFiltersAction } from "../../store/actions";
import withSocketContext from '../../context-api/SocketContext/withSocketContext';
import { withUserInactivity } from "../../components/UserInactivity";
import API from "../../requests";

export interface Props {
  reduxProps: StateType;
}

export interface State {
  popup: PopupContentType | typeof undefined;
}

const SERVER_TIPS = 'server-tips';

class TeamShare extends Component<Props, State> {
  constructor(props) {
    super(props);

    this.state = {
      popup: undefined,
      selectedItem: {},
      items: [],
      filteredChecks: [],
      revenueCenters: [],
      searchValue: '',
      paidCheck: false,
      premise: true,
    }

    this.checks = new Map();
    this.onIntialize = null;
    this.toggleType = [];
  }

  componentDidMount() {
    const {
      history,
      reduxProps: { storeInfo, deviceInfo, teamshareFilterPersist },
    } = this.props;

    if (window.ReactNativeWebView) {
      EventEmitter.addLogs(
        'appLogs',
        LogLevelEnum.INFO,
        `Mounting TeamShare component with storeId ${storeInfo?.data?.id} and deviceExternalId ${deviceInfo?.deviceExternalId}`
      );
    }
    if (!storeInfo.data || !deviceInfo.deviceExternalId) {
      history.push({
        pathname: '/',
        state: { deviceTypeId: 8 }
      });
      return;
    }

    if (window.ReactNativeWebView) {
      EventEmitter.initializeIngenico();
    }

    this.toggleType = teamshareFilterPersist?.data?.revenueCenters || [];
    const { revenueCenters } = storeInfo.data || {};
    let revenueCentersName = [];
    revenueCenters.forEach(revenue => revenueCentersName.push({ 'label': revenue.name, 'value': revenue.id }));
    const { premise } = teamshareFilterPersist?.data;
    this.setState({
      revenueCenters: revenueCentersName,
      premise,
    });

    const { context } = this.props;
    const { checks } = context;
    this.checks = checks;
    this.setChecks(checks);

  }

  componentWillUnmount() {
    // this.unsubscribeRethinkListeners();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props?.context !== nextProps?.context) {
      const { checks } = nextProps.context;
      this.setChecks(checks);
    }
  }

  setChecks = checks => {
    this.checks = checks;
    this.onToggleOrderType(this.toggleType, true);
  };

  getDataFromRedis = (callback) => {
    this.getAllChecks(callback);
  };

  getAllChecks = (callback) => {
    const {
      reduxProps: { storeInfo, serverAppLogin },
    } = this.props;
    const { id: storeId } = storeInfo.data;

    const checksCallback = (error, response) => {
      if (error) {
        EventEmitter.addLogs(
          'syncLogs',
          LogLevelEnum.ERROR,
          "Get store checks errored out"
        );
        const errorMsg = error.response
          ? error.response.data
          : error.message;
        this.getPopup("error", null, errorMsg);
      } else {
        response.forEach((check) => {
          check.orderTypeName = this.getOrderTypeName(check.orderTypeId);
          check.revenueCenterName = this.getRevenueCenterName(
            check.revenueCenterId,
          );
          //parse check as per the requirements on team share screen
          this.checks.set(check.id, check);
        });
        EventEmitter.addLogs(
          'syncLogs',
          LogLevelEnum.INFO,
          `Response from Get store checks. Total number of checks - ${this.checks.size}`
        );
        callback && callback();
        console.log("response from getallchecks", response, this.checks);
        this.onToggleOrderType(this.toggleType);
      }
    }

    DBManager.getStoreChecks(storeId, checksCallback);
  };

  getOrderTypeName = (id) => {
    const { reduxProps } = this.props;
    const { storeInfo } = reduxProps;
    const orderTypeDetails = storeInfo.data.orderTypes.find(
      (each) => each.id === id
    );
    if (orderTypeDetails) {
      return orderTypeDetails.name;
    }
    return "";
  };

  getRevenueCenterName = (id) => {
    const { reduxProps } = this.props;
    const { storeInfo } = reduxProps;
    const revenueCenterDetails = storeInfo.data.revenueCenters.find(
      (each) => each.id === id
    );
    if (revenueCenterDetails) {
      return revenueCenterDetails.name;
    }
    return "";
  };

  reSync = () => {
    const callback = () => {
      this.getPopup('spinner', constants.sync, null);
      this.unsubscribeRethinkListeners();
      this.onIntialize = DBManager.addListener('initialize', this.reSync);
      this.checks = new Map();
      const onSuccess = () => {
        this.closePopup();
      };
      EventEmitter.addLogs(
        'syncLogs',
        LogLevelEnum.INFO,
        'Syncing with your POS'
      );
      this.getDataFromRedis(onSuccess);
    };
    callback();
  };

  unsubscribeRethinkListeners = () => {
    this.onIntialize && this.onIntialize();
  };

  getPopup = (type, heading, message, callback) => {
    const popup =
      type === "spinner"
        ? getPopupConfig("spinner")
        : getPopupConfig("error", () => {
          callback && callback();
          this.setState({ popup: undefined });
        });
    if (heading) {
      popup.heading = heading;
    }
    if (message) {
      popup.message = message;
    }
    this.setState({ popup });
  };

  closePopup = () => {
    this.setState({ popup: undefined });
  };

  getPickupTime = check => {
    const order = check.orders && check.orders[0];
    if (check.sourceType === 6 || check.sourceType === 8) {
      return FireboardUtils.getTimeInHrsMins(order.pickupDate);
    }
    if (check.sourceType === 0) {
      const pickupDate = order.pickupDate || order.orderDate;
      return FireboardUtils.getTimeInHrsMins(pickupDate);
    }
    return FireboardUtils.getTimeInHrsMins(order.pickupDate);
  }

  get checksRowData() {
    const { reduxProps } = this.props;
    const { currencyInfo } = reduxProps || {};
    const { iso2 } = currencyInfo || {};
    const { filteredChecks } = this.state;

    const rowData =
      Array.isArray(filteredChecks) &&
      filteredChecks.length &&
      filteredChecks.map((check) => {
        const orders = check?.orders.length && check.orders[0] || {};
        return {
          checkNumber: check.number || "- -",
          revenueCenterName: check.revenueCenterName || '- -',
          orderNumber: orders.externalOrderNumber || '- -',
          deliverTo: check.tab ? check.name || orders.checkInNote || '- -' : check.name || check.stationName || orders.checkInNote || '- -',
          vehicleInfo: orders.vehicleInfo || '- -',
          phoneNumber: orders.phoneNumber
            ? FireboardUtils.formattedPhoneNumber(orders.phoneNumber, iso2)
            : "- -",
          pickupDate: this.getPickupTime(check),
          employeeName: check.employeeFirstName || '- -',
          orderType: check.orderTypeName || '- -',
          id: check.id,
          items: check.items,
          selectedCheckDetails: check,
          unpaidAmount: check.unpaidAmount,
          paidAmount: check.paidAmount,
          referenceId: check.referenceId,
          totalAmount: check.totalAmount,
          orders: check.orders,
          seats: check.seats,
          tickets: check.tickets,
          stationId: check.stationId,
          open: check.open,
          checksum: check.checksum,
          subTotalAmount: check.subTotalAmount,
          taxAmount: check.taxAmount,
          tipAmount: check.tipAmount,
          unformattedPhoneNumber: orders.phoneNumber,
        };
      });
    return rowData ? rowData : [];
  };

  setSelectedCheck = item => {
    let { selectedItem, items, premise } = this.state;
    if (!premise && selectedItem && selectedItem.id === item.id) {
      selectedItem = {};
      items = [];
    } else {
      selectedItem = { ...item };
      items = item && item.items;
    }
    this.setState({
      items,
      selectedItem,
    });
  };

  preparePaymentInput = () => {
    const { selectedItem: ticketData, items } = this.state;
    const preAuthAvailability = FireboardUtils.getPreAuthAvailability({ checks: [ticketData] });
    const { subTotalAmount, taxAmount, tipAmount } = ticketData;
    const taxRate = subTotalAmount !== 0 ? taxAmount / subTotalAmount : 0;
    const tempPaymentInput = FireboardUtils.preparePaymentInput(
      [ticketData],
      taxRate,
      items,
      ticketData.seats,
      true,
      ticketData?.selectedCheckDetails?.stationName,
      this.currency,
    );
    return {
      ...tempPaymentInput,
      checkHeaderId: ticketData.id,
      tableSeats: ticketData.seats.length,
      stationId: ticketData.stationId,
      checksum: ticketData.checksum,
      preAuthTickets: preAuthAvailability,
      tipAmount: tipAmount,
      tickets: ticketData.tickets,
      checkHeaderId: ticketData.id,
      unformattedPhoneNumber: ticketData.unformattedPhoneNumber,
      amountToBePaid: tempPaymentInput.unpaidAmount,
      ticketSplitTypeId: 1,
      splitValue: 1,
      checkTotalAmount: tempPaymentInput.totalTotalAmount,
      checkUnpaidAmount: tempPaymentInput.unpaidAmount,
    };
  };

  onPaymentClick = check => {
    const { history } = this.props;
    const paymentInput = this.preparePaymentInput();
    dispatchUpdateChecks(this.checks);
    // history.push({
    //   pathname: '/paymentOptions',
    //   state: { check: check, paymentInput: paymentInput }
    // });
  }

  onSplitPay = check => {
    const { history } = this.props;
    const paymentInput = this.preparePaymentInput();
    const tickets = check.tickets;
    const paidAmount = check.paidAmount;
    let disableSplitPersonFlow = false;
    let disableSelectItemsFlow = false;
    let splitValue = 0;
    let splitValueToConsider = 0;
    if (paidAmount > 0) {
      if (tickets && tickets.length > 0) {
        const existingPaymentTicket = tickets.find(each => (each.ticketSplitTypeId === 0 || each.ticketSplitTypeId === 1) && each.ticketStatusId === 1);
        if (existingPaymentTicket) {
          disableSplitPersonFlow = true;
          disableSelectItemsFlow = true;
        } else {
          const hasSplitTickets = tickets.find(each => each.ticketSplitTypeId === 3 && each.ticketStatusId === 1);
          const hasSelectItemsTickets = tickets.find(each => each.ticketSplitTypeId === 4 && each.ticketStatusId === 1);
          if (hasSplitTickets && hasSelectItemsTickets) {
            disableSplitPersonFlow = true;
            disableSelectItemsFlow = true;
          } else if (hasSplitTickets) {
            disableSelectItemsFlow = true;
            const splitTickets = tickets.filter(each => each.ticketSplitTypeId === 3 && each.ticketStatusId === 1);
            if (splitTickets && splitTickets.length > 0) {
              splitValueToConsider = splitTickets[0].splitValue - splitTickets.length;
              splitValue = splitTickets[0].splitValue;
            }
          } else if (hasSelectItemsTickets) {
            disableSplitPersonFlow = true;
          }
        }
      } else {
        disableSplitPersonFlow = true;
        disableSelectItemsFlow = true;
      }
    }
    dispatchUpdateChecks(this.checks);
    // history.push({
    //   pathname: '/paymentSelection',
    //   state: {
    //     check: check, paymentInput: {
    //       ...paymentInput,
    //       disableSplitPersonFlow,
    //       disableSelectItemsFlow,
    //       splitValue,
    //       splitValueToConsider,
    //     }
    //   }
    // });
  }

  onToggleOrderType = (type, isSubscription) => {
    let newFilteredChecks;
    const { searchValue, paidCheck, selectedItem, items } = this.state;
    const { reduxProps } = this.props;
    const { storeInfo } = reduxProps;
    const { serverAppFeatures: { suppressZeroDollarChecks = false } } = storeInfo.data || {};
    let allCheck = CommonUtil.getTeamChecks(this.checks, paidCheck || false);
    allCheck = suppressZeroDollarChecks
      ? paidCheck ? allCheck.filter(check => check.totalAmount > 0) : allCheck.filter(check => check.totalAmount > 0 && check.unpaidAmount !== 0)
      : paidCheck ? allCheck.filter(check => (check.totalAmount > 0) || check.totalAmount === 0) : allCheck.filter(check => (check.totalAmount > 0 && check.unpaidAmount !== 0) || check.totalAmount === 0);
    if (type && Array.isArray(type) && type.length) {
      newFilteredChecks = [];
      type.forEach(tp => {
        const filteredVal = allCheck.filter(check => check.revenueCenterId === tp.value);
        newFilteredChecks = [...newFilteredChecks, ...filteredVal];
      })
      this.toggleType = type;
    } else {
      newFilteredChecks = allCheck;
      this.toggleType = [];
    }

    this.setState(
      {
        filteredChecks: newFilteredChecks,
        selectedItem: isSubscription ? selectedItem : {},
        items: isSubscription ? items : [],
      },
      () => {
        const { filteredChecks } = this.state;
        if (!!searchValue && filteredChecks && filteredChecks.length > 0) this.onSearchTable(searchValue);
      }
    );
  }

  onChangeFilter = value => {
    const { dispatchUpdateFilter } = this.props;
    const pData = {
      revenueCenters: value,
    };
    dispatchUpdateFilter(pData);
    this.onToggleOrderType(value);
  };

  onSearch = event => {
    this.setState(
      {
        searchValue: event.target.value
      },
      () => this.onToggleOrderType(this.toggleType)
    );
  };

  onSearchTable = searchValue => {
    const { filteredChecks } = this.state;
    if (searchValue && filteredChecks) {
      const filteredCheckValue = filteredChecks.filter(check => {
        const orders = check.orders;
        const phone = orders && orders.length > 0 && orders[0].phoneNumber ? orders[0].phoneNumber : null;
        const vehicleInfo = orders && orders.length > 0 && orders[0].vehicleInfo ? orders[0].vehicleInfo : null;
        const checkInNote = orders && orders.length > 0 && orders[0].checkInNote ? orders[0].checkInNote : null;
        if (this.isContainsValue(check.number, searchValue) ||
          this.isContainsValue(check.revenueCenterName, searchValue) ||
          this.isContainsValue(check.orderTypeName, searchValue) ||
          this.isContainsValue(phone, searchValue) ||
          this.isContainsValue(vehicleInfo, searchValue) ||
          this.isContainsValue(checkInNote, searchValue)) {
          return check;
        }
      });
      filteredCheckValue.sort(CommonUtil.sortFunction);
      this.setState({ filteredChecks: filteredCheckValue });
    }
  };

  isContainsValue = (value, searchValue) => {
    return value && value.toLowerCase().includes(searchValue.toLowerCase());
  };

  onLogout = () => {
    const { history } = this.props;
    history && history.push("/serverApp");
  };

  filterPaidCheck = paidCheck => {
    this.state.paidCheck = paidCheck;
    this.onToggleOrderType(this.toggleType);
  };

  nameInitials = () => {
    const {
      reduxProps: { serverAppLogin },
    } = this.props;
    let nameInitialsText = '';
    if (serverAppLogin.data) {
      const { firstName, lastName } = serverAppLogin.data;
      nameInitialsText = `${firstName ? firstName.charAt(0) : ''}${lastName ? lastName.charAt(0) : ''
        }`;
    }
    return nameInitialsText;
  };

  togglePremise = e => {
    const premise = e.target.checked;
    const { dispatchUpdateFilter } = this.props;
    this.setState({ premise });
    const payload = { premise };
    dispatchUpdateFilter(payload);
  };

  handleErrorPopup = (error) => {
    const errorMsg = error.response
      ? error.response.data
      : error.message;
    FireboardUtils.addNetworkLogs(error.response);
    this.getPopup("error", null, errorMsg);
  };

  showTipsInfo = () => {
    this.getPopup("spinner", "Fetching Server Tips...", null);
    const {
      reduxProps: { storeInfo, serverAppLogin },
    } = this.props;
    API.getTips({
      storeId: storeInfo?.data?.id,
      employeeId: serverAppLogin?.data?.id,
    })
      .then((res) => {
        this.setState({
          popup: {
            type: SERVER_TIPS,
            metaData: res.data,
          },
        });
        FireboardUtils.addNetworkLogs(res);
      })
      .catch((error) => this.handleErrorPopup(error));
  };


  getProps = () => {
    const {
      popup,
      selectedItem,
      items,
      revenueCenters,
      searchValue,
      paidCheck,
      premise,
    } = this.state;
    const {
      reduxProps: { storeInfo, serverAppLogin, currencyInfo },
    } = this.props;
    const { currency = '$' } = currencyInfo || {};
    const { supportsTipsOnTotalAmount = false, suppressTipsOnFireBoard = false } = storeInfo && storeInfo.data ? storeInfo.data.serverAppFeatures : {};
    let job = null;
    if (serverAppLogin.data && serverAppLogin.data.jobId) {
      job = storeInfo.data && storeInfo.data.jobs.find(j => j.id === serverAppLogin.data.jobId);
    }
    return {
      popup,
      closePopup: this.closePopup,
      checksRowData: this.checksRowData,
      selectedItem,
      items,
      setSelectedCheck: this.setSelectedCheck,
      onPay: this.onPaymentClick,
      onChangeFilter: this.onChangeFilter,
      revenueCenters,
      searchValue,
      onSearch: this.onSearch,
      reSync: this.reSync,
      onLogout: this.onLogout,
      supportsTipsOnTotalAmount,
      suppressTipsOnFireBoard,
      paidCheck,
      filterPaidCheck: this.filterPaidCheck,
      job: job,
      nameInitials: this.nameInitials(),
      name: serverAppLogin.data ? `${serverAppLogin.data.firstName} ${serverAppLogin.data.lastName}` : '',
      premise,
      togglePremise: this.togglePremise,
      showTipsInfo: this.showTipsInfo,
      currency,
      onSplitPay: this.onSplitPay,
    };
  }

  render() {
    const viewProps = this.getProps();
    return <View {...viewProps} />;
  }
}

const mapStateToProps = reduxProps => ({
  reduxProps,
});

const mapDispatchToProps = (dispatch) => ({
  dispatchUpdateFilter: (payload) => {
    dispatch(updateFiltersAction(payload));
  },
});

export default connect(
  mapStateToProps, mapDispatchToProps
)(withSocketContext(withUserInactivity(TeamShare)));

